import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import { Global as EmotionGlobal, css } from '@emotion/react';
import emotionNormalize from 'emotion-normalize';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var Global = function Global() {
  return _jsx(EmotionGlobal, {
    styles: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      ", "\n\n      .uconsent-container {\n        width: 100%;\n        padding-bottom: 16px;\n        margin: 0 24px;\n        overflow: hidden;\n        transition: padding-bottom 0.5s, max-height 0.5s;\n      }\n\n      .email .uconsent-container {\n        padding-bottom: 16px;\n        max-height: 94px;\n        @media (max-width: 320px) {\n          max-height: 114px;\n        }\n      }\n    "])), emotionNormalize)
  });
};

export default Global;